import { MessageDescriptor, useIntl } from 'react-intl';

import { Homepage_5Stars, QuoteIcon } from '@calm-web/icons';

import FiveStarMessages from '@/components/ui/StarRating/messages';

import HomepageCarousel from '../HomepageCarousel';
import { Author, ContentWrapper, Heading, Quote, ReviewItem, Wrapper } from './styles';
import { Review } from './types';

export type TestimonialsProps = {
	reviews: Review[];
	reviewsHeading: MessageDescriptor;
};

const Testimonials = ({ reviews, reviewsHeading }: TestimonialsProps) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<ContentWrapper>
				<Heading>{formatMessage(reviewsHeading)}</Heading>
				<HomepageCarousel
					slideItems={reviews.map(review => ({
						key: formatMessage(review.author),
						Slide: () => (
							<ReviewItem>
								<QuoteIcon width="64" height="64" />
								<blockquote>
									<Quote>{formatMessage(review.quote)}</Quote>
								</blockquote>
								<Author>{formatMessage(review.author)}</Author>
								<Homepage_5Stars
									height="24"
									width="136"
									aria-label={formatMessage(FiveStarMessages.ariaLabel)}
								/>
							</ReviewItem>
						),
					}))}
					numSlides={{
						desktopLarge: 3,
						desktop: 2,
						tablet: 2,
						mobile: 1,
					}}
					slideGap={{
						desktopLarge: 48,
						desktop: 36,
						tablet: 16,
						mobile: 8,
					}}
				/>
			</ContentWrapper>
		</Wrapper>
	);
};

export default Testimonials;
